import { createSelector } from "reselect";
import { sectionsSelector } from "../../sections_selector";

export const exportsSectionSelector = createSelector(
  sectionsSelector,
  sections => {
    return sections.exports;
  }
);
